import React from 'react';
import { EducationTooltipHeaderProps } from '../types';

const EducationTooltipHeader = ({ children }: EducationTooltipHeaderProps) => <header>{children}</header>;

EducationTooltipHeader.displayName = 'EducationTooltipHeader';

export default EducationTooltipHeader;
